import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/_atoms/button";
import { LoadingDots } from "@/components/_molecules/loading-dots/loading-dots";
import { APIError } from "@/services/errors.service";

import { request2FAResetLink } from "../services/auth.service";

export default function TwoFactorAuthForgottenForm() {
  const { t } = useTranslation("auth");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    const email = e.currentTarget.email.value;

    try {
      await request2FAResetLink(email);
      setErrors([]);
      setSuccessMessage(t("twoFactor.forgotten.successMessage", { email }));
    } catch (e) {
      setErrorMessages(e);
    } finally {
      setLoading(false);
    }
  };

  const setErrorMessages = (error: unknown) => {
    if (error instanceof APIError) {
      setErrors(error.toArray());
    } else if (error instanceof Error) {
      setErrors([error.message]);
    } else {
      setErrors([t("twoFactor.errors.generic")]);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col space-y-4 bg-background px-4 py-8 sm:px-16">
      <div>
        <label htmlFor="email" className="block text-xs text-foreground">
          {t("twoFactor.forgotten.emailLabel")}
        </label>
        <input
          id="email"
          name="email"
          type="email"
          placeholder="max.mustermann@kommune.de"
          autoComplete="email"
          required
          className="mt-1 block w-full appearance-none rounded-md border bg-transparent px-3 py-2 shadow-xs placeholder:text-muted-foreground focus:border-foreground focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus sm:text-sm"
        />
      </div>
      <div className="text-sm">
        {errors.length > 0 && (
          <ul className="list-none text-destructive">
            <li>{t("twoFactor.errors.generic")}</li>
          </ul>
        )}
        {successMessage && <ul className="list-none text-green-500">{successMessage}</ul>}
      </div>
      <Button type="submit" disabled={loading} className="w-full">
        {loading ? <LoadingDots color="#808080" /> : <p>{t("twoFactor.forgotten.submitButton")}</p>}
      </Button>
    </form>
  );
}
